export const emptyObject = {};
